import script from "./dx-download.vue?vue&type=script&setup=true&lang=js"
export * from "./dx-download.vue?vue&type=script&setup=true&lang=js"

import "./dx-download.vue?vue&type=style&index=0&id=34a94622&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34a94622"]])

export default __exports__